import environment from '../environment';

function formatTenantLink(tenantId: string, path: string): string {
  return `${environment.API_URL}/v1/tenants/${tenantId}/redir/${path.replace(/#/g, '%23')}`;
}

export default formatTenantLink;
